import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getPayment } from 'services/PaymentsService'
import { QueryMetaType } from 'types/reactQuery'

export const useGetPaymentQuery = (uuid: string, enabled = true) => {
  const meta: QueryMetaType = {
    errorAdditionalData: { uuid },
  }

  return useQuery({
    queryKey: reactQueryKeys.payment(uuid),
    queryFn: () => getPayment(uuid),
    enabled,
    meta,
  })
}
